import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import 'react-tooltip/dist/react-tooltip.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
